import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { useRecentSearchAPI, useRecentSearchData } from '../../hooks/apiHooks';
import { postContextFeedbackThunk } from '../../thunks/postContextFeedbackThunk';

const RecordRecentSearchesFeedback = ({ children, type }) => {
  const recentSearchData = useRecentSearchData();
  const { trackingId } = useRecentSearchAPI();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(postContextFeedbackThunk({ recentSearchData, lob: type, trackingId }));
    // eslint-disable-next-line react-hooks/exhaustive-deps -- We only want to run this effect once
  }, []);
  return (
    children
  );
};

export default RecordRecentSearchesFeedback;
